function getErrorFromErrorResponse(error: any) {
  if (error?.response?.data?.error) {
    // For validation errors (400 status), preserve the actual error message
    throw new Error(error.response.data.error);
  } else if (error?.response?.data?.detail) {
    // For other errors with detail field
    throw new Error(error.response.data.detail);
  }
  // For other cases, return the original error
  return error;
}

export default getErrorFromErrorResponse;
